// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"PassedCourses_wrapper__1tIGf","title":"PassedCourses_title__1ajVD"};